<template>
    <div class="modal" :class="{'is-active':isActiveNotamJsonModal}">
        <div @click="$emit('closeNotamJsonModal')" class="modal-background"></div>
        <div class="modal-content" style="width: 60%;height: 70%">

        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <h2 class="modal-title">{{headerFlightText}} - Notam info from Jetplan</h2>
            </div>
            <button class="close-btn" @click="$emit('closeNotamJsonModal')" >
              <font-awesome-icon icon="times" />
            </button>
          </div>
        </div>

                <section class="modal-card-body">
                    <pre v-if="S_WNReqJetP_Data && S_WNReqJetP_Data.weatherNote">{{S_WNReqJetP_Data.weatherNote}}</pre>
                    <div v-for="post in DataList" :key="post.idx">

                        <div v-for="p in post.NotamInfoList" :key="p.idx">

                            <pre v-html="getValueWithImportantWord(p.NotamInfo)"></pre>
                        </div>
                    </div>
                </section>

            <footer class="modal-card-foot">
            </footer>
        </div>
    </div>

</template>

<script>
    import ScheduleService from "../../services/schedule.service";


    export default {
        name: "NotamJsonModal",

        data() {
            return {
                NotamImportantList:[],
                StatuColorArray :[
                    "#f14668",
                    "#48c774",
                    "#FDA50F",
                    "#FDA50F",
                    "#FDA50F",
                    "#FDA50F",
                ],
            }
        },

        props: ['isActiveNotamJsonModal','WRJsonData','S_WNReqJetP_Data', 'headerFlightText'],

        created() {
            // buraya notam json modal kısmında api den çekme işlemini gerçekleştirelim.
            this.getNotamImportantWordList();

        },

        computed : {

            DataList: function()
            {

                if (this.WRJsonData != null){

                    return this.WRJsonData.LIST_USED_AIRPORTS;
                }
                else {
                    return "";
                }
            }

        },

        mounted() {

            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27) { //ESC
                    this.$emit('closeNotamJsonModal');
                }
            })

        },

        methods: {

            async getNotamImportantWordList()
            {
                var wordlist= await ScheduleService.GetNotamImportantList();
                this.NotamImportantList = wordlist;
            },

            getValueWithImportantWord(value)
            {
                var i;
                for (i = 0; i < this.NotamImportantList.length; i++) {

                    this.NotamImportantList[i]
                    value=value.replaceAll(this.NotamImportantList[i].word.toString().toUpperCase(),"<span style='color: "+this.NotamImportantList[i].color+";font-weight: '"+this.NotamImportantList[i].style+"'>"+this.NotamImportantList[i].word.toString().toUpperCase()+"</span>");

                }
                return value;
            }

        }
    }
</script>

<style scoped>

</style>
